import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Icon from 'components/Icon'
import Link from 'components/Link'
import links from 'misc/links'
import { StepTitle } from '../StepInfo'
import scrollPosition from 'decorators/scrollPosition'
import './styles.sass'

import { TransitionMotion, spring } from 'react-motion'

const WizardHeader = ({ wizard, windowScrollY }) => (
  <div className={cx('wizard-header', (windowScrollY > 20 || !wizard.currentStep.title) && 'wizard-header--compact')}>
    <div className="inner">
      <div className="wizard-header-buttons is-left">
        <HeaderButton
          visible={wizard.showBackButton}
          icon="arrow back"
          onClick={() => wizard.back()}
        >
            Back
          </HeaderButton>

      </div>
      <div className="wizard-header-step-info">
        <CoolTransition
          transitionKey={wizard.currentStep.title}
          // Based on whether we're going backwards or forwards.
          invert={wizard.stepDelta < 0}
          wrapperClassName="step-title-container"
        >
          <StepTitle>{wizard.currentStep.title}</StepTitle>
        </CoolTransition>
      </div>
      <div className="wizard-header-buttons is-right">
        <HeaderButton visible icon="close" onClick={() => wizard.syncJob()} to={links.projects()} index>Esc</HeaderButton>
      </div>
    </div>
  </div>
)

export default scrollPosition(observer(WizardHeader))

const HeaderButton = ({ icon, visible, children, ...props }) => (
  <Link className={cx('button is-header-button', !visible && 'is-invisible')} {...props}>
    <Icon material name={icon} />
    <span>{children}</span>
  </Link>
)

class CoolTransition extends React.Component {
  willEnter = () => ({
    opacity: 0,
    y: this.props.invert ? -40 : 40
  })

  getStyles = () => ({
    opacity: spring(1),
    y: spring(0)
  })

  willLeave = () => ({
    // Makes it fade out a little faster.
    opacity: spring(0, { stiffness: 244, damping: 21 }),
    y: spring(this.props.invert ? 40 : -40)
  })

  render () {
    const { transitionKey, children, wrapperClassName } = this.props
    return (
      <TransitionMotion
        willEnter={this.willEnter}
        willLeave={this.willLeave}
        styles={[{
          key: transitionKey,
          style: this.getStyles(),
          data: children
        }]}
      >
        {interpolated => (
          <div>
            {interpolated.map(({ key, style, data }) => (
              <div
                key={key}
                className={wrapperClassName}
                style={{
                  opacity: style.opacity,
                  transform: `translateX(${style.y}px)`
                }}
              >
                {data}
              </div>
            ))}
          </div>)
        }
      </TransitionMotion>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/WizardHeader/index.jsx